import React from 'react';
import { useSelector } from 'react-redux';
import { State } from 'src/types';

interface Props {
  permission: string | string[];
  children: React.ReactNode;
}

export const SystemPermissionRequired = ({ permission, children }: Props) => {
  const systemPermissions = useSelector(
    (state: State) => state.globalUsers.currentUser?.systemPermissions,
  );
  if (Array.isArray(permission)) {
    const hasPermission = permission.some((perm) =>
      systemPermissions?.includes(perm),
    );
    if (hasPermission) {
      return <>{children}</>;
    }
    return null;
  }
  if (systemPermissions?.includes(permission)) {
    return <>{children}</>;
  }
  return null;
};
